import { render, staticRenderFns } from "./UserLoanRequests.vue?vue&type=template&id=10c2990a"
import script from "./UserLoanRequests.vue?vue&type=script&lang=js"
export * from "./UserLoanRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports